export default __webpack_public_path__ + "static/media/Client.a0bfbd4e.svg";